import { makeStyles } from '@material-ui/styles';
import { ITheme } from '../../../style/theme';

export const useStyles = makeStyles<ITheme>((theme) => ({
  chipWrapper: {
    display: 'flex',
    gap: 8,
    flexWrap: 'wrap',
    margin: '8px 0',
  },
  chip: {
    background: theme.eventColors.default,
    padding: '10px 16px',
    borderRadius: 80,
    whiteSpace: 'nowrap',
    fontWeight: 'bold',
    letterSpacing: 0.25,
    fontSize: 14,
  },
}));
